import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { GbeEndPointV4 } from '../models/gbe/gbe-endpoint.enum';
import { GbeTokensService } from '../services/gbe-tokens/gbe-tokens.service';
import { GBE_BASE_URL } from '../tokens/gbe-url.token';

const IGNORE_PATHS = [GbeEndPointV4.HEALTH];

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const gbeBaseUrl = inject(GBE_BASE_URL);
  const tokenService = inject(GbeTokensService);

  const isTargeted = req.url.startsWith(gbeBaseUrl);
  if (!isTargeted) return next(req);

  if (IGNORE_PATHS.some((path) => req.url.includes(path))) {
    return next(req);
  }

  const accessToken = tokenService.getAccessToken();
  const authReq = accessToken
    ? req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
    : req;
  return next(authReq);
};
